import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import { Seo } from "../components/Seo";

export default function Artists() {
  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/artists").then((r) => setArtists(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="pt-32 pb-24 max-w-7xl mx-auto px-6 lg:px-10 min-h-screen" data-testid="artists-page">
      <Seo title="Les Artistes" description="Rencontrez les artistes handicapés de la Fondation : leur univers, leur style et leurs œuvres à vendre." path="/artistes" />
      <p className="text-xs uppercase tracking-[0.3em] text-[#60a5fa] mb-3">Nos talents</p>
      <h1 className="font-display text-5xl md:text-6xl text-white tracking-tight mb-6">Les Artistes</h1>
      <p className="text-zinc-400 max-w-xl mb-14 leading-relaxed">
        Chaque artiste possède son univers, son style et son histoire. Découvrez leur personnalité et explorez leurs œuvres.
      </p>

      {loading ? (
        <p className="text-zinc-500">Chargement…</p>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
          {artists.map((a, i) => (
            <motion.div
              key={a.slug}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.1 }}
              data-testid={`artist-card-${a.slug}`}
            >
              <Link to={`/artiste/${a.slug}`} className="group block">
                <div className="aspect-[3/4] overflow-hidden bg-[#0d0d0d] relative">
                  {a.photo ? (
                    <img src={a.photo} alt={a.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  ) : (
                    <div className="h-full w-full flex items-center justify-center text-zinc-700 font-display text-6xl">
                      {a.name.charAt(0)}
                    </div>
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
                  <div className="absolute bottom-0 left-0 p-6">
                    <h3 className="font-display text-3xl text-white">{a.name}</h3>
                    {a.style && <p className="text-[#60a5fa] text-sm mt-1">{a.style}</p>}
                  </div>
                </div>
                <div className="flex items-center justify-between mt-4">
                  <span className="text-zinc-500 text-sm">{a.count} œuvre{a.count > 1 ? "s" : ""}</span>
                  <span className="inline-flex items-center gap-2 text-zinc-300 group-hover:text-white text-sm transition-colors">
                    Voir l'univers <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
}
